const initSliders = () => {
    new Swiper('.collection-slider__swiper', {
        slidesPerView: 'auto',
        spaceBetween: 20,
        breakpoints: {
            1200: {
                slidesPerView: 3
            }
        }
    })

    new Swiper('.main-blog__swiper', {
        slidesPerView: 'auto',
        spaceBetween: 20,
        breakpoints: {
            1200: {
                slidesPerView: 4
            }
        }
    })

    new Swiper('.store-info__swiper', {
        slidesPerView: 'auto',
        spaceBetween: 10,
        autoplay: {
            delay: 2000
        },
        loop: true,
        breakpoints: {
            768: {
                slidesPerView: 2
            },
            992: {
                slidesPerView: 3,
                autoplay: false
            },
            1200: {
                spaceBetween: 0,
            }
        }
    })


    new Swiper('.partner-highlights__swiper', {
        slidesPerView: 'auto',
        spaceBetween: 20,
        breakpoints: {
            768: {
                slidesPerView: 2
            },
            992: {
                slidesPerView: 3,
            }
        }
    })

    new Swiper('.products-slider-tabs__swiper', {
        slidesPerView: 'auto',
        spaceBetween: 20,
        navigation: {
            prevEl: '.products-slider-tabs-button-prev',
            nextEl: '.products-slider-tabs-button-next'
        },
        breakpoints: {
            992: {
                autoplay: false
            }
        }
    })

    new Swiper('.products-slider__swiper', {
        slidesPerView: 'auto',
        spaceBetween: 7,
        navigation: {
            prevEl: '.products-slider-button-prev',
            nextEl: '.products-slider-button-next'
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
                spaceBetween: 20,
            }
        }
    })

    new Swiper('.logo-carousel__slider', {
        slidesPerView: 'auto',
        spaceBetween: 50,
        breakpoints: {
            768: {
                slidesPerView: 4
            },
            992: {
                slidesPerView: 4,
                autoplay: {
                    delay: 1500
                }
            }
        }
    })

    const reviewSliderThumbs = new Swiper('.reviews-slider__thumbs', {
        slidesPerView: 3,
        spaceBetween: 8,
        freeMode: true,
        watchSlidesProgress: true,
        
    })

    new Swiper('.reviews-slider__main', {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 20,
        effect: 'slide',
        navigation: {
            prevEl: '.reviews-slider__main-button-prev',
            nextEl: '.reviews-slider__main-button-next',
        },
        thumbs: {
            swiper: reviewSliderThumbs,
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
                centeredSlides: false,
            },
            1200: {
                slidesPerView: 1,
                effect: 'fade',
            }
        }
    })
    
    new Swiper('.topbar__slider', {
       slidesPerView: 1,
       loop: true,
       effect: 'fade',
       autoplay: {
        delay: 3000
       } 
    })

    const productGalleryThumbs = new Swiper(".product-gallery-thumbs", {
        centeredSlides: false,
        centeredSlidesBounds: false,
        slidesPerView: 4,
        watchOverflow: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        direction: 'vertical',
        navigation: {
            prevEl: '.product-gallery-thumbs-prev',
            nextEl: '.product-gallery-thumbs-next'
        }
    });

    new Swiper(".product-gallery-main", {
        watchOverflow: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        preventInteractionOnTransition: true,
        pagination: {
          el: '.product-gallery-main-pagination'
        },
        effect: 'fade',
          fadeEffect: {
          crossFade: true
        },
        thumbs: {
          swiper: productGalleryThumbs
        }
    });

    new Swiper(".product-highlights__swiper", {
        slidesPerView: 'auto',
        spaceBetween: 20,
        breakpoints: {
            992: {
                slidesPerView: 3
            }
        }
    })
}

export { initSliders }